import { CSSProperties } from "react"

const card: CSSProperties = {
  padding: 5,
  paddingTop: 3,
  width: 300
}

export { card }